<template>
  <div
    v-if="pageData && pageData.app_type"
    class="outer-container"
    ref="container"
    :style="
      pageData && pageData.background_color
        ? 'background:' + pageData.background_color
        : ''
    "
  >
    <div class="editor-header">
      <span v-if="pageData && pageData.name">{{ pageData.name }}</span>
    </div>
    <draggable
      v-if="pageData"
      class="editor-main"
      :list="pageData.module_list"
      :options="draggableOptions.page"
      @end="draggableEnd"
      @start="drag = false"
      ref="editorMain"
    >
      <div
        class="editor-main-module-box"
        @click="editMod(item, index)"
        :class="[currentEditModIndex === index ? 'module-action-content' : '']"
        v-for="(item, index) in pageData.module_list"
        :key="index"
      >
        <div class="editor-main-module">
          <component
            :is="`tms-${item.module_code}`"
            :isEditorStatus="true"
            :config="item"
            :theme="theme"
            :page-data="pageData"
          ></component>
        </div>
        <div v-if="currentEditModIndex === index" class="module-action-box">
          <div class="action-btn">
            <div
              class="com-operate-img"
              @click.stop.prevent="upMod(index)"
              v-on:mouseover="btnIconIndexHover = 1"
              v-on:mouseout="btnIconIndexHover = 0"
            >
              <img
                :src="
                  btnIconIndexHover == 1
                    ? 'https://mktv-in-cdn.mockuai.com/16432741511274951.png'
                    : 'https://mktv-in-cdn.mockuai.com/16432741511325399.png'
                "
                alt="向上移动"
              />
            </div>
            <div
              class="com-operate-img"
              @click.stop.prevent="downMod(index)"
              v-on:mouseover="btnIconIndexHover = 2"
              v-on:mouseout="btnIconIndexHover = 0"
            >
              <img
                :src="
                  btnIconIndexHover == 2
                    ? 'https://mktv-in-cdn.mockuai.com/16432741511416526.png'
                    : 'https://mktv-in-cdn.mockuai.com/16432741511365008.png'
                "
                alt="向下移动"
              />
            </div>
            <div
              class="com-operate-img"
              @click.stop.prevent="copyMod(index)"
              v-on:mouseover="btnIconIndexHover = 3"
              v-on:mouseout="btnIconIndexHover = 0"
            >
              <img
                :src="
                  btnIconIndexHover == 3
                    ? 'https://mktv-in-cdn.mockuai.com/16432741511151703.png'
                    : 'https://mktv-in-cdn.mockuai.com/16432741511111661.png'
                "
                alt="复制"
              />
            </div>
            <div
              class="com-operate-img"
              @click.stop.prevent="rmModConfirm(index)"
              v-on:mouseover="btnIconIndexHover = 4"
              v-on:mouseout="btnIconIndexHover = 0"
            >
              <img
                :src="
                  btnIconIndexHover == 4
                    ? 'https://mktv-in-cdn.mockuai.com/16432741511236700.png'
                    : 'https://mktv-in-cdn.mockuai.com/16432741511203026.png'
                "
                alt="删除"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="module-list-empty" v-if="pageData.module_list.length === 0">
        请先将左侧组件库中的组件移入
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Utils from "@/js/util";
export default {
  props: ["pageData", "currentEditModIndex", "theme"],
  data() {
    return {
      draggableOptions: {
        // 页面组件拖拽配置
        page: {
          group: {
            name: "module",
          },
          ghostClass: "dnd-placeholder",
        },
      },
      btnIconIndexHover: 0,
    };
  },
  components: {
    draggable,
  },
  created() {
    Utils.createRem(375);
  },
  methods: {
    draggableEnd(event) {
      this.$emit("draggableEnd", event);
    },
    editMod(item, index) {
      this.$emit("editMod", item, index);
    },
    rmModConfirm(index) {
      this.$emit("rmModConfirm", index);
    },
    upMod(index) {
      if (
        !index ||
        this.pageData.module_list[index].module_code == "bottom_nav" ||
        this.pageData.module_list[index].module_code == "bottom_float"
      ) {
        this.$message("已经置顶了!");
        return;
      }
      this.$emit("upMod", index);
    },
    downMod(index) {
      if (index >= this.pageData.module_list.length - 1) {
        this.$message("已经到底了!");
        return;
      }
      this.$emit("downMod", index);
    },
    copyMod(index) {
      this.$emit("copyMod", index);
    },
  },
};
</script>

<style lang="scss" scoped>
.editor-header {
  background: url(https://mktv-in-cdn.mockuai.com/16432742326293610.png)
    no-repeat;
  background-size: 100%;
  text-align: center;
  justify-content: center;
  height: 62px;
  padding: 0 80px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  line-height: 84px;
  /*! autoprefixer: off */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  /* autoprefixer: on  */
}
.dnd-placeholder {
  width: 100%;
  height: 45px;
  background: url(../../../assets/placeholder.png) no-repeat center;
  background-size: cover;
  text-indent: -9999em;
  * {
    display: none;
  }
}
.outer-container {
  width: 100%;
  position: relative;
  overflow: visible;
  background: #fff;
  box-shadow: 0px 0px 8px 4px #dbdbdb;
}
.editor-main {
  position: relative;
  left: 0;
  height: 100%;
  overflow-x: visible;
  overflow-y: visible;
  min-height: 665px;
}

.editor-main::-webkit-scrollbar {
  display: none;
}

.module-list-empty {
  width: 373px;
  text-align: center;
  line-height: 665px;
  font-size: 16px;
}

.editor-main-module-box {
  width: 371px;
  cursor: pointer;
  position: relative;
  padding: 0px;
  border: none;
  box-sizing: border-box;
  &:hover {
    &::before {
      content: "";
      position: absolute;
      width: 373px;
      height: 100%;
      left: -1px;
      top: 0;
      box-sizing: border-box;
      border: 1px dashed #155bd4;
      z-index: 99;
      cursor: move;
    }
  }
}
.module-action-content {
  &::before {
    content: "";
    position: absolute;
    width: 375px !important;
    height: 100%;
    left: -2px !important;
    top: 0;
    box-sizing: border-box;
    border: 2px solid #155bd4 !important;
    z-index: 99;
    cursor: move;
  }
}
.module-action-box {
  position: absolute;
  top: 0px;
  width: 371px;
  z-index: 100;

  .action-name {
    position: absolute;
    top: 0;
    right: -50px;
    width: 80px;
    .action-name-content {
      min-width: 68px;
      min-height: 24px;
      padding: 4px 7px;
      box-sizing: border-box;
      position: absolute;
      right: 0;
      top: 0;
      background: red;
    }
  }
  .action-btn {
    position: absolute;
    top: 0;
    right: -42px;
    width: 40px;
    height: 141px;
    background: #fff;
    box-shadow: 0 2px 8px 0 #f0f0f0;
    border-radius: 2px;
    padding: 2px 0;
    box-sizing: border-box;
    .com-operate-img {
      cursor: pointer;
      width: 100%;
      height: 34px;
      position: relative;
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
